export default __webpack_public_path__ + "static/media/telegram.2bc88f3f.png";